module.exports = __webpack_public_path__ + "static/img/donate_close.46eb7280.svg";